import React from 'react';

function bindReduceStore(store, propKey, transformer = state => state) {
  return Component => (
    class Container extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          transformedStoreState: transformer(store.getState()),
        };

        this._onChange = this._onChange.bind(this);
      }

      componentDidMount() {
        this.storeSubscription = store.addListener(this._onChange);
      }

      componentWillUnmount() {
        this.storeSubscription.remove();
      }

      _onChange() {
        this.setState({ transformedStoreState: transformer(store.getState()) });
      }

      render() {
        const stateProp = { [propKey]: this.state.transformedStoreState };
        return <Component {...this.props} {...stateProp} />;
      }
    }
  );
}

export default bindReduceStore;
